export const func = ({dispatch, getState}) => (next) => (action) => {
  if (typeof action === "function") {
    action(dispatch,getState);// remember, here we have used action as a function
  } else {
    next(action);
  }
};
